<template>
  <div class="classContainer">
    <van-nav-bar
      title="学员列表"
      left-text=""
      left-arrow
      :border="false"
      @click-left="onClickLeft"
    />
    <div class="listBox">
      <van-search
        v-model="keyword"
        shape="round"
        placeholder="请输入姓名、工号、手机号搜索"
        clearable
        show-action
        @search="onSearch"
        @cancel="onCancel"
      />
      <div class="listBox-item" v-for="(item, index) in studentList" :key="item.id">
        <div class="left">
          <img src="@/assets/images/avatar.png" alt="" />
          <div class="content-info">
            <div class="name">
              {{item.userName}}
            </div>
            <div class="identity">
              {{item.className?item.className:'-'}}
            </div>
          </div>
        </div>
        <div :class="[item.homeworkStatus==1?'gray':'','right']">
          {{ item.homeworkStatus==1?'已完成':'未完成' }}
          <template v-if="item.homeworkStatus==1">
            <span class="copScore" v-if="item.homeWorkScore">{{ item.homeWorkScore }}分</span>
            <span class="copScore" v-else @click="showScoreDialog(item)">评分</span>
          </template>

        </div>
      </div>
    </div>
    <van-dialog v-model="showScore" title="评分" show-cancel-button confirmButtonColor="#3776ff" @confirm="confirmScore">
      <van-field
        class="noteTextarea"
        v-model="score"
        type="digit"
        input-align="center"
        placeholder="请输入分数"
      />
    </van-dialog>
  </div>
</template>

<script>
import {listHomeworkStudent, updateScoreBatch} from "@/api/classSchedule";

export default {
  name: "checkStudent",
  data() {
    return {
      planDetailId:'',
      studentList:[],
      keyword: '',
      showScore:false,
      userId:'',
      score:100
    }
  },
  methods: {
    onClickLeft(){
      this.$router.go(-1)
    },
    async getStudentList(){
      let res = await listHomeworkStudent({planDetailId:this.planDetailId,keyword:this.keyword});
      this.studentList = res.data;
    },
    onSearch(){
      this.getStudentList()
    },
    onCancel(){
      this.keywords = ''
      this.getStudentList()
    },
    showScoreDialog(item){
      this.userId = item.userId;
      this.showScore = true;
    },
    async confirmScore(){
      if(this.score>100 || this.score<0){
        this.$message.warning('分数范围为0-100');
        return;
      }
      let params = [{
        planDetailId:this.planDetailId,
        userId:this.userId,
        homeWorkScore:this.score
      }];
      let res = await updateScoreBatch(params)
      this.showScore = false;
      this.getStudentList()
    }
  },
  mounted() {
    this.planDetailId = this.$route.query.planDetailId;
    this.getStudentList()
  },
}
</script>
<style scoped lang="scss">
::v-deep .van-nav-bar .van-icon{
  color: #2F2F46
}
.listBox {
  height: calc(100vh - 46px);
  overflow-y: auto;
  padding: 16px;
  padding-top: 0;

  .listBox-item {
    width: 341px;
    height: 80px;
    border-bottom: 1px solid #EEEEEE;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .left {
      height: 48px;
      display: flex;
      img {
        height: 48px;
        width: 48px;
      }
      .content-info {
        margin-left: 12px;
        .name {
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 15px;
          color: #121212;
          line-height: 21px;
          font-style: normal;
        }
        .identity {
          margin-top: 6px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 13px;
          color: #000000;
          line-height: 18px;
          font-style: normal;
          max-width: 200px;
        }
      }
    }
    .right {
      display: flex;
      flex-flow: column;
      align-items: center;
      font-size: 15px;
      color: #3776FF;
      .gray{
        color: #8F91A1;
      }
      // width: 32rpx;
      img {
        width: 16px;
        height: 16px;
      }
      .copScore{
        margin-top: 5px;
      }
    }
  }
}
</style>
